import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TranslateService } from "@shared-services/translate.service";
import { TokenManager } from "@core-managers/token.manager";
import { IRedeemInitiatives, IRedeemMadeInMexico } from "@core-models/payments.model";
import { UrlQueryDef } from "@shared-base/url-query-definition.base";
import { EntityDataServiceBase } from "@shared-base/entity-data-service.base";

@Injectable({ providedIn: 'root' })
export class PaymentsDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient,
    protected tokenManager: TokenManager,
    protected translateService: TranslateService)
  {
    super(http, 'payments');
  }

  public redeemMadeInMexico(dto: IRedeemMadeInMexico): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    const token = this.tokenManager.getToken();

    const subject = this.http.post(this.createMicroserviceURL('specialPromotions/redeemMadeInMexico'), dto, queryDef.getRequestConfigWithAuthorizationToken(token, this.translateService.languageCode));
    return subject;
  }

  public redeemInitiatives(dto: IRedeemInitiatives): Observable<any>
  {
    const queryDef = new UrlQueryDef();
    const token = this.tokenManager.getToken();

    const subject = this.http.post(this.createMicroserviceURL('specialPromotions/redeemInitiative'), dto, queryDef.getRequestConfigWithAuthorizationToken(token, this.translateService.languageCode));
    return subject;
  }
}
